import {
  Line,
  Tooltip,
  TooltipContent,
  TooltipHead
} from '@deque/cauldron-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PasswordRequirementsProps {
  namespace: string;
  requirements: string[];
  target: React.RefObject<HTMLInputElement | null>;
  id?: string;
}

const PasswordRequirements = ({
  namespace,
  requirements,
  target,
  id
}: PasswordRequirementsProps): React.ReactElement | null => {
  const { t } = useTranslation();

  return requirements.length ? (
    <Tooltip target={target} variant="big" placement="auto-start" id={id}>
      <TooltipHead>{t('Password requirements')}</TooltipHead>
      <Line />
      <TooltipContent>
        <ul>
          {requirements.map(requirement => (
            <li key={`${namespace}${requirement}`}>{requirement}</li>
          ))}
        </ul>
      </TooltipContent>
    </Tooltip>
  ) : null;
};

export default PasswordRequirements;
